import { Reveal } from "./Reveal";

export const SectionHeading = ({ index, title, id }) => (
    <Reveal className="px-6 md:px-12 mb-14 md:mb-24">
        <div id={id} className="flex items-end justify-between border-b border-[var(--line)] pb-5 scroll-mt-24">
            <div className="flex items-baseline gap-4 md:gap-8">
                <span className="font-mono2 text-[11px] md:text-xs text-[var(--mute)] tracking-widest" data-testid={`${id}-index`}>
                    {index}
                </span>
                <h2 className="font-display text-3xl sm:text-4xl md:text-6xl uppercase leading-none tracking-tight" data-testid={`${id}-title`}>
                    {title}
                </h2>
            </div>
        </div>
    </Reveal>
);
